var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pagination is-centered mt2"},[_c('ul',{staticClass:"pagination-list"},_vm._l((_vm.range),function(page){return _c('li',[_c('a',{class:[
          'pagination-link',
          { 'is-current': page === parseInt(_vm.current, 10) }
        ],on:{"click":function($event){$event.preventDefault();return _vm.onClick(page)}}},[_vm._v("\n        "+_vm._s(page)+"\n      ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }